// Stimulus controllers — registered per-phase on first use.
import { application } from "./application"

// Phase 1: Auth + Org
import ToastController from "./toast_controller"
import LoadingButtonController from "./loading_button_controller"
import ModalController from "./modal_controller"
import FormValidationController from "./form_validation_controller"
import AutoDismissController from "./auto_dismiss_controller"
import PasswordToggleController from "./password_toggle_controller"

application.register("toast", ToastController)
application.register("loading-button", LoadingButtonController)
application.register("modal", ModalController)
application.register("form-validation", FormValidationController)
application.register("auto-dismiss", AutoDismissController)
application.register("password-toggle", PasswordToggleController)

// Phase 2: Plants
import ProgressiveRevealController from "./progressive_reveal_controller"
import LeafletMapController from "./leaflet_map_controller"
import LeafletPlantsMapController from "./leaflet_plants_map_controller"

application.register("progressive-reveal", ProgressiveRevealController)
application.register("leaflet-map", LeafletMapController)
application.register("leaflet-plants-map", LeafletPlantsMapController)

// Phase 3: Templates
import SortableItemsController from "./sortable_items_controller"
import SectionReorderController from "./section_reorder_controller"
import LivePreviewController from "./live_preview_controller"
import CharacterCounterController from "./character_counter_controller"
import SkeletonController from "./skeleton_controller"
import ShiftConfigController from "./shift_config_controller"

application.register("sortable-items", SortableItemsController)
application.register("section-reorder", SectionReorderController)
application.register("live-preview", LivePreviewController)
application.register("character-counter", CharacterCounterController)
application.register("skeleton", SkeletonController)
application.register("shift-config", ShiftConfigController)

// Phase 4: Shifts
import ShiftTimerController from "./shift_timer_controller"
import AutoRefreshController from "./auto_refresh_controller"

application.register("shift-timer", ShiftTimerController)
application.register("auto-refresh", AutoRefreshController)

// Phase 6: Reporting
import ChartController from "./chart_controller"

application.register("chart", ChartController)

// Branding
import BrandingPreviewController from "./branding_preview_controller"

application.register("branding-preview", BrandingPreviewController)

// UI/UX Polish
import ThemeToggleController from "./theme_toggle_controller"
import NotificationBellController from "./notification_bell_controller"

application.register("theme-toggle", ThemeToggleController)
application.register("notification-bell", NotificationBellController)

// C8: Push Notifications + ActionCable
import PushPermissionController from "./push_permission_controller"
import NotificationChannelController from "./notification_channel_controller"

application.register("push-permission", PushPermissionController)
application.register("notification-channel", NotificationChannelController)

// Phase 8: PWA
import InstallPromptController from "./install_prompt_controller"
import ClipboardController from "./clipboard_controller"
import ConnectionStatusController from "./connection_status_controller"
import SyncStatusController from "./sync_status_controller"
import OfflineFormController from "./offline_form_controller"

application.register("install-prompt", InstallPromptController)
application.register("clipboard", ClipboardController)
application.register("connection-status", ConnectionStatusController)
application.register("sync-status", SyncStatusController)
application.register("offline-form", OfflineFormController)

// Particle trail effect (Holi colors)
import ParticleTrailController from "./particle_trail_controller"

application.register("particle-trail", ParticleTrailController)

// 12h AM/PM time picker (replaces <input type="time"> which forces 24h on IN locale)
import TimePicker12hController from "./time_picker_12h_controller"

application.register("time-picker-12h", TimePicker12hController)

// Compare plants checkbox selector (enable Compare button when 2-3 plants selected)
import CompareSelectorController from "./compare_selector_controller"

application.register("compare-selector", CompareSelectorController)

// Keeps sidebar active link highlight in sync when the sidebar is data-turbo-permanent
import SidebarActiveController from "./sidebar_active_controller"

application.register("sidebar-active", SidebarActiveController)
